import React from "react";
import { Modal } from "antd";
import "../../../../assets/style/modalStyle/postNews.scss";
import { useDispatch, useSelector } from "react-redux";
import TranslateText from "../../TranslateText";
import imageLogo from "../../../../assets/images/image 9.png";
import "../../../../assets/style/modalStyle/detailSurvey.scss";
import { useEffect } from "react";
import { getDetailReportSurveyByCard } from "../../../../services/slice/SurveySlice";
import { surveySelector } from "../../../../services/selector/index.";
import SelectAnswer from "../../Survey/SelectAnswer";
import StarRate from "../../Survey/StarRate";
import EmotionRate from "../../Survey/EmotionRate";
import EnterContent from "../../Survey/EnterContent";
import { data } from "autoprefixer";
const ModalDetailSurveyByCard = ({ open, setOpen, payloadConfig }) => {
  const dispatch = useDispatch();
  const surveyState = useSelector(surveySelector);
  const { dataDetailSurveyByCard } = surveyState;
  const handCancel = () => {
    setOpen(false);
  };
  useEffect(() => {
    dispatch(getDetailReportSurveyByCard(payloadConfig));
  }, [dispatch, payloadConfig]);
  return (
    <>
      <Modal
        title={<TranslateText text="Xem thông tin" />}
        centered
        width={815}
        open={open}
        onCancel={handCancel}
        footer={false}
        className="modalDetailBycard"
      >
        <p className="textBold">Mã khách hàng: {payloadConfig.card}</p>
        <p style={{ fontSize: "18px" }} className="textBold">
          Thời gian phải hồi: {payloadConfig.time}
        </p>
        <div className="wrapperContentModalDetailCard">
          {dataDetailSurveyByCard?.data?.questionList?.map((item, index) => {
            if (item.typeQuestions === 1) {
              return (
                <>
                  <p className="nameQuestion">
                    {index + 1}. {item.questionName}
                  </p>
                  <div style={{ marginLeft: "20px" }}>
                    <SelectAnswer type={1} dataAnswer={item.answerList} />
                  </div>
                </>
              );
            } else if (item.typeQuestions === 2) {
              return (
                <>
                  <p className="nameQuestion">
                    {index + 1}. {item.questionName}
                  </p>
                  <div style={{ marginLeft: "20px" }}>
                    <SelectAnswer type={2} dataAnswer={item.answerList} />
                  </div>
                </>
              );
            } else if (item.typeQuestions === 3) {
              return (
                <>
                  <p className="nameQuestion">
                    {index + 1}. {item.questionName}
                  </p>
                  <div style={{ marginLeft: "20px", width: "300px" }}>
                    <StarRate data={item} />
                  </div>
                </>
              );
            } else if (item.typeQuestions === 4) {
              return (
                <>
                  <p className="nameQuestion">
                    {index + 1}. {item.questionName}
                  </p>
                  <div style={{ marginLeft: "20px", width: "380px" }}>
                    <EmotionRate data={item} />
                  </div>
                </>
              );
            } else {
              return (
                <>
                  <p className="nameQuestion">
                    {index + 1}. {item.questionName}
                  </p>
                  <div style={{ marginLeft: "20px", width: "380px" }}>
                    <EnterContent value={item.answer} data={item} />
                  </div>
                </>
              );
            }
          })}
        </div>
      </Modal>
    </>
  );
};

export default ModalDetailSurveyByCard;
